import React from "react";
import { AppShell } from "./AppShell.js";
import { getRoleConfig, RoleKey } from "../roles/config.js";
import clsx from "clsx";

export type PracticeAppProps = {
  role: RoleKey;
  className?: string;
  children?: React.ReactNode;
};

// Shared practice app wrapper; renders provided role-specific children inside the shared shell.
export function PracticeApp({ role, className, children }: PracticeAppProps) {
  const config = getRoleConfig(role);

  return (
    <AppShell className={className}>
      {children ?? (
        <div
          className={clsx("p-6 text-sm text-neutral-700")}
          data-role={config.id}
        >
          <p className="font-semibold">{config.displayName}</p>
        </div>
      )}
    </AppShell>
  );
}
